import { Injectable, NgZone } from "@angular/core";
import { AuthService } from './firebase/auth.service'
@Injectable({
  providedIn: "root",
})
export class AutoLogoutService {
  //log off details
  isLogin = false;

  constructor(private ngZone: NgZone, private authService: AuthService) {
    this.inicializarTimeout(); //Inicializa la activacion del timeout de inactividad
  }

  inicializarTimeout(){
    if (this.isUserLoggedIn()) {
      this.isLogin = true;
    }
    this.lastAction(Date.now());
    this.check();
    this.initListener();
    this.initInterval();
  }

  /**
   * last action
   */
  getLastAction() {
    return localStorage.getItem("lastAction") || "[]";
  }


  // tracker() {
  //   window.addEventListener("mousemove", this.eventHandler);
  //   window.addEventListener("scroll", this.eventHandler);
  //   window.addEventListener("keydown", this.eventHandler);
  // }
  /**
   * set last action
   */
  lastAction(value) {
    localStorage.setItem("lastAction", JSON.stringify(value));
  }

  /**
   * start event listener
   */
  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener("click", () => this.reset());
    });
  }

  /**
   * time interval // Intervalo de revision de eventos
   */
  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, 300000);
    });
  }

  /**
   * reset timer // resetea el timer cada vez que se activa un evento
   */
  reset() {
    this.lastAction(Date.now());
  }

  /**
   * check timer
   */
  check() {
    const now = Date.now();
    const timeLeft = parseInt(this.getLastAction()) + ((5 * 60 * 10000)/2); //30 Minutos
    const diff = timeLeft - now;
    const isTimeout = diff < 0;
    //this.isLoggedIn.subscribe(event => this.isLogin = event);
    this.ngZone.run(() => {
      // if (isTimeout && this.isLogin) { - > se quita si esta logeado porque el token se refresca y solo se va a validar el timeout
      if (isTimeout) {
        localStorage.removeItem("lastAction");
        setTimeout(() => {
          console.error(
            "La sesion a expirado por inactividad, volver a iniciar sesion"
          );
          this.authService.SignOutTimeOut();
        }, 10000);
        // this.router.navigate(['login']); Llama al Logout porque ya paso el tiempo de inactividad
      }
    });
  }

  /**
   *check if a user is logged in
   */
  isUserLoggedIn(): string {
    // return environment.authKey;
    return "key";
  }
}
